module.exports = __webpack_public_path__ + "img/wg_funded_negative.136f8490.png";